import React from 'react';
import { CheckCircle, Shield, Users, MapPin } from 'lucide-react';
import { usps, anniversaryText } from '../../data/mock';

const iconMap = {
  1: Shield,
  2: Users,
  3: CheckCircle,
  4: MapPin
};

const WhyUs = () => {
  return (
    <section className="py-24 lg:py-32 bg-slate-900 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
        }} />
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-10 relative z-10">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block text-teal-400 font-semibold text-sm uppercase tracking-wider mb-4">
            Ihre Vorteile
          </span>
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-6">
            Warum ADMIN Hausverwaltung?
          </h2>
          <p className="text-lg text-slate-400">
            Vertrauen Sie auf unsere langjährige Erfahrung und persönliche Betreuung.
          </p>
        </div>

        {/* USPs Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {usps.map((usp) => {
            const IconComponent = iconMap[usp.id];
            return (
              <div
                key={usp.id}
                className="text-center group"
              >
                <div className="w-16 h-16 bg-teal-600/20 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:bg-teal-600 transition-colors duration-300">
                  <IconComponent className="w-8 h-8 text-teal-400 group-hover:text-white transition-colors duration-300" />
                </div>
                <h3 className="text-xl font-bold text-white mb-2">
                  {usp.title}
                </h3>
                <p className="text-slate-400">
                  {usp.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Anniversary Banner */}
        <div className="mt-20 bg-gradient-to-r from-teal-600/20 to-teal-600/10 rounded-2xl p-8 lg:p-12 border border-teal-600/30">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-6">
            <div className="flex items-center gap-4">
              <div className="w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0">
                <span className="text-2xl font-bold text-white">25</span>
              </div>
              <div>
                <h3 className="text-xl lg:text-2xl font-bold text-white">
                  25 Jahre Jubiläum
                </h3>
                <p className="text-teal-300">
                  {anniversaryText}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
